/* Minimal observability utilities for production logging/error tracking.
 * Replace console transports with a real provider (e.g., Sentry, Logtail, Datadog) when credentials are available.
 */

type LogLevel = 'info' | 'warn' | 'error';

const sendLog = (level: LogLevel, message: string, data?: Record<string, any>) => {
  const payload = { level, message, data, ts: new Date().toISOString() };
  if (level === 'error') {
    console.error('[obs]', payload);
  } else if (level === 'warn') {
    console.warn('[obs]', payload);
  } else {
    console.info('[obs]', payload);
  }
};

export const Observability = {
  logEvent: (message: string, data?: Record<string, any>) => sendLog('info', message, data),
  logWarn: (message: string, data?: Record<string, any>) => sendLog('warn', message, data),
  logError: (message: string, error?: unknown, data?: Record<string, any>) => {
    const err = error instanceof Error ? { name: error.name, message: error.message, stack: error.stack } : error;
    sendLog('error', message, { error: err, ...(data || {}) });

    // Placeholder for Sentry/Bugsnag
    // Sentry.captureException(error, { extra: data });
  },
  attachGlobalHandlers: () => {
    if (typeof window === 'undefined') return;

    // Initializing instrumentation placeholder
    console.log('[obs] Instrumentation initialized');

    window.addEventListener('error', (event) => {
      sendLog('error', 'UncaughtError', { message: event.message, source: event.filename, lineno: event.lineno, colno: event.colno, error: event.error?.stack });
    });
    window.addEventListener('unhandledrejection', (event) => {
      sendLog('error', 'UnhandledPromiseRejection', { reason: (event.reason as any)?.message || event.reason });
    });
  },
};

